module.exports = __webpack_public_path__ + "images/07_d229cca7.png";